import AppSystemWebApiModelBase from '../_generated/modelBases/app-system-web-api-model-base';

export default class AppSystemWebApiModel extends AppSystemWebApiModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
